import type { RiskMetricsResponse } from "../../../../types/trade";

/** True when the API returned trade-derived risk metrics or drawdown series for the period. */
export function riskMetricsHasData(
  data: RiskMetricsResponse | null | undefined
): boolean {
  if (!data) return false;
  if ((data.drawdown_data?.length ?? 0) > 0) return true;
  return (
    data.max_drawdown !== null ||
    data.max_drawdown_percent !== null ||
    data.sharpe_ratio !== null ||
    data.sortino_ratio !== null ||
    data.calmar_ratio !== null ||
    data.risk_reward_ratio !== null ||
    data.volatility !== null ||
    data.average_losing_trade !== null
  );
}
